module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point01_sp-ea526e1a59d09426d254a20df410e011.png";